import { Factory } from "@/repository/Factory";
const Project = Factory.get("project");

const state = {
  projects: []
};

const actions = {
  // List Project
  async getProjects({ commit }, payload) {
    commit("setProjects", []);

    return await Project.getProjects(payload).then(
      response => {
        if (response.status === 200) {
          commit("setProjects", response.data);

          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // List Project Users
  async getProjectUsers({ commit }, payload) {
    return await Project.getProjectUsers(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Create Project
  async createProject({ commit }, payload) {
    return await Project.createProject(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );

          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Update Project
  async updateProject({ commit }, payload) {
    return await Project.updateProject(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );

          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Delete Project
  async deleteProject({ commit }, payload) {
    return await Project.deleteProject(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );

          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Invite Users
  async inviteUsers({ commit }, payload) {
    return await Project.inviteUser(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );

          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        // commit(
        //   "setToast",
        //   {
        //     message: message,
        //     type: "error",
        //     show: true
        //   },
        //   { root: true }
        // );

        return Promise.reject(message);
      }
    );
  }
};

const mutations = {
  setProjects(state, projects) {
    state.projects = JSON.parse(JSON.stringify(projects));
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
